import(/* webpackMode: "eager" */ "/app/src/app/watchlist/page.tsx");
